import Lenis from "lenis";

export const scrollStore = { lenis: null };

export function initLenis() {
  const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
  scrollStore.lenis = lenis;
  let raf;
  const loop = (t) => {
    lenis.raf(t);
    raf = requestAnimationFrame(loop);
  };
  raf = requestAnimationFrame(loop);
  return () => {
    cancelAnimationFrame(raf);
    lenis.destroy();
    scrollStore.lenis = null;
  };
}

export function scrollToTarget(target) {
  if (scrollStore.lenis) {
    scrollStore.lenis.scrollTo(target, { offset: -76, duration: 1.4 });
  } else {
    document.querySelector(target)?.scrollIntoView({ behavior: "smooth" });
  }
}
